module.exports = __webpack_public_path__ + "static/media/foodie.212e3b50.jpg";